const topics = [
  {
    id: 1,
    title: '热血战斗合集',
    count: '328部',
    tag: '日漫经典',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20action%20manga%20illustration%20with%20dynamic%20fighting%20poses%20and%20explosive%20energy%20effects%2C%20warm%20orange%20and%20red%20toned%20background%2C%20Japanese%20shonen%20manga%20style%2C%20clean%20composition%20with%20bold%20linework%20and%20dramatic%20lighting%2C%20cinematic%20anime%20aesthetic&width=600&height=400&seq=index-topic-1&orientation=landscape',
  },
  {
    id: 2,
    title: '恋爱校园合集',
    count: '256部',
    tag: '人气推荐',
    image: 'https://readdy.ai/api/search-image?query=Soft%20romantic%20manga%20illustration%20with%20cherry%20blossom%20petals%20and%20school%20uniform%20characters%2C%20gentle%20pink%20and%20cream%20color%20palette%2C%20shojo%20manga%20art%20style%2C%20dreamy%20atmospheric%20lighting%2C%20clean%20elegant%20composition%2C%20emotional%20tender%20mood&width=600&height=400&seq=index-topic-2&orientation=landscape',
  },
  {
    id: 3,
    title: '悬疑推理合集',
    count: '187部',
    tag: '烧脑精选',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20suspense%20manga%20illustration%20with%20dark%20silhouettes%20and%20dramatic%20shadow%20play%2C%20deep%20indigo%20and%20warm%20amber%20accent%20tones%2C%20thriller%20manga%20art%20style%2C%20moody%20atmospheric%20composition%20with%20intricate%20details%2C%20cinematic%20noir%20lighting&width=600&height=400&seq=index-topic-3&orientation=landscape',
  },
  {
    id: 4,
    title: '搞笑日常合集',
    count: '312部',
    tag: '轻松一刻',
    image: 'https://readdy.ai/api/search-image?query=Playful%20comedy%20manga%20illustration%20with%20expressive%20chibi%20characters%20and%20colorful%20speech%20bubbles%2C%20bright%20cheerful%20yellow%20and%20cream%20tones%2C%20slice%20of%20life%20manga%20style%2C%20lively%20joyful%20composition%20with%20comic%20effects%2C%20fun%20upbeat%20atmosphere&width=600&height=400&seq=index-topic-4&orientation=landscape',
  },
  {
    id: 5,
    title: '奇幻异世界合集',
    count: '243部',
    tag: '热门连载',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20isekai%20manga%20illustration%20with%20magical%20landscapes%20and%20adventuring%20characters%2C%20rich%20emerald%20green%20and%20golden%20warm%20tones%2C%20epic%20fantasy%20manga%20art%20style%2C%20grand%20sweeping%20composition%20with%20detailed%20worldbuilding%2C%20enchanting%20atmospheric%20lighting&width=600&height=400&seq=index-topic-5&orientation=landscape',
  },
  {
    id: 6,
    title: '国漫崛起合集',
    count: '168部',
    tag: '国产精品',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20with%20elegant%20ink%20wash%20painting%20style%20and%20mythological%20elements%2C%20warm%20vermilion%20and%20jade%20green%20tones%2C%20traditional%20Chinese%20art%20meets%20modern%20comic%20aesthetic%2C%20graceful%20flowing%20composition%20with%20cultural%20motifs%2C%20artistic%20refined%20atmosphere&width=600&height=400&seq=index-topic-6&orientation=landscape',
  },
  {
    id: 7,
    title: '韩漫精选合集',
    count: '145部',
    tag: '条漫专区',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20with%20sleek%20modern%20character%20designs%20and%20urban%20backdrops%2C%20cool%20muted%20tones%20with%20warm%20accent%20lighting%2C%20contemporary%20digital%20manhwa%20aesthetic%2C%20stylish%20clean%20composition%20with%20vertical%20scroll%20motifs%2C%20trendy%20atmospheric%20mood&width=600&height=400&seq=index-topic-7&orientation=landscape',
  },
  {
    id: 8,
    title: '经典完结合集',
    count: '398部',
    tag: '永久收藏',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20manga%20collection%20with%20vintage%20comic%20book%20spines%20and%20aged%20paper%20textures%2C%20warm%20sepia%20and%20cream%20tones%2C%20retro%20manga%20art%20style%2C%20timeless%20elegant%20composition%20like%20a%20library%20shelf%2C%20sentimental%20atmospheric%20lighting&width=600&height=400&seq=index-topic-8&orientation=landscape',
  },
  {
    id: 9,
    title: '新番速递合集',
    count: '96部',
    tag: '当季热追',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20new%20manga%20releases%20display%20with%20glossy%20cover%20art%20and%20vibrant%20colors%2C%20energetic%20modern%20manga%20illustration%20style%2C%20bright%20dynamic%20composition%20with%20new%20arrival%20stickers%2C%20exciting%20fresh%20atmosphere%2C%20contemporary%20editorial%20design%20feel&width=600&height=400&seq=index-topic-9&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            主题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按题材快速找到您想看的51漫画下载资源，支持51漫画免费版下载全集离线看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              className="group block relative rounded-xl overflow-hidden aspect-[3/2] cursor-pointer"
            >
              <img
                src={topic.image}
                alt={`${topic.title} - 51漫画下载`}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full whitespace-nowrap">
                  {topic.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="font-heading text-lg text-background-50 mb-1">
                  {topic.title}
                </h3>
                <p className="text-xs text-background-50/70">{topic.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}